import { call, put, takeLatest } from 'redux-saga/effects';
import i18n from '../../../i18n';
import visitTypeCategoryService from '../../../services/visitTypeCategoryService';
import {
  fetchVisitTypeCategories,
  fetchVisitTypeCategoriesSuccess,
  fetchVisitTypeCategoriesFailure,
  fetchVisitTypeCategoryById,
  fetchVisitTypeCategoryByIdSuccess,
  fetchVisitTypeCategoryByIdFailure,
  addVisitTypeCategory,
  addVisitTypeCategorySuccess,
  addVisitTypeCategoryFailure,
  updateVisitTypeCategory,
  updateVisitTypeCategorySuccess,
  updateVisitTypeCategoryFailure,
  deleteVisitTypeCategory,
  deleteVisitTypeCategorySuccess,
  deleteVisitTypeCategoryFailure,
  bulkDeleteVisitTypeCategories,
  bulkDeleteVisitTypeCategoriesSuccess,
  bulkDeleteVisitTypeCategoriesFailure,
} from './slice';

/**
 * Translate error message from backend
 */
function translateError(errorMessage) {
  if (!errorMessage) return i18n.t('visitTypeCategories.errors.unknown');

  const errorMap = {
    'Visit type category name already exists': 'visitTypeCategories.errors.nameExists',
    'Visit type category not found': 'visitTypeCategories.errors.visitTypeCategoryNotFound',
    'Failed to add visit type category': 'visitTypeCategories.errors.addFailed',
    'Failed to update visit type category': 'visitTypeCategories.errors.updateFailed',
    'Failed to delete visit type category': 'visitTypeCategories.errors.deleteFailed',
    'Failed to fetch visit type categories': 'visitTypeCategories.errors.fetchFailed',
    'Cannot delete visit type category that is being used by visit types': 'visitTypeCategories.errors.cannotDeleteInUse',
  };

  for (const [key, translationKey] of Object.entries(errorMap)) {
    if (errorMessage.includes(key)) {
      return i18n.t(translationKey);
    }
  }

  return errorMessage;
}

function* handleFetchVisitTypeCategories(action) {
  try {
    const response = yield call(visitTypeCategoryService.getVisitTypeCategories, action.payload);
    yield put(fetchVisitTypeCategoriesSuccess(response));
  } catch (error) {
    const translatedError = translateError(error.message);
    yield put(fetchVisitTypeCategoriesFailure(translatedError));
  }
}

function* handleFetchVisitTypeCategoryById(action) {
  try {
    const response = yield call(visitTypeCategoryService.getVisitTypeCategoryById, action.payload);
    yield put(fetchVisitTypeCategoryByIdSuccess(response));
  } catch (error) {
    const translatedError = translateError(error.message);
    yield put(fetchVisitTypeCategoryByIdFailure(translatedError));
  }
}

function* handleAddVisitTypeCategory(action) {
  try {
    const response = yield call(visitTypeCategoryService.createVisitTypeCategory, action.payload);
    yield put(addVisitTypeCategorySuccess(response));
  } catch (error) {
    const translatedError = translateError(error.message);
    yield put(addVisitTypeCategoryFailure(translatedError));
  }
}

function* handleUpdateVisitTypeCategory(action) {
  try {
    const response = yield call(visitTypeCategoryService.updateVisitTypeCategory, action.payload);
    yield put(updateVisitTypeCategorySuccess(response));
  } catch (error) {
    const translatedError = translateError(error.message);
    yield put(updateVisitTypeCategoryFailure(translatedError));
  }
}

function* handleDeleteVisitTypeCategory(action) {
  try {
    const visitTypeCategoryId = action.payload;
    yield call(visitTypeCategoryService.deleteVisitTypeCategory, visitTypeCategoryId);
    yield put(deleteVisitTypeCategorySuccess(visitTypeCategoryId));
  } catch (error) {
    const translatedError = translateError(error.message);
    yield put(deleteVisitTypeCategoryFailure(translatedError));
  }
}

function* handleBulkDeleteVisitTypeCategories(action) {
  try {
    const visitTypeCategoryIds = action.payload;
    yield call(visitTypeCategoryService.bulkDeleteVisitTypeCategories, visitTypeCategoryIds);
    yield put(bulkDeleteVisitTypeCategoriesSuccess(visitTypeCategoryIds));
  } catch (error) {
    const translatedError = translateError(error.message);
    yield put(bulkDeleteVisitTypeCategoriesFailure(translatedError));
  }
}

export function* watchVisitTypeCategoriesActions() {
  yield takeLatest(fetchVisitTypeCategories.type, handleFetchVisitTypeCategories);
  yield takeLatest(fetchVisitTypeCategoryById.type, handleFetchVisitTypeCategoryById);
  yield takeLatest(addVisitTypeCategory.type, handleAddVisitTypeCategory);
  yield takeLatest(updateVisitTypeCategory.type, handleUpdateVisitTypeCategory);
  yield takeLatest(deleteVisitTypeCategory.type, handleDeleteVisitTypeCategory);
  yield takeLatest(bulkDeleteVisitTypeCategories.type, handleBulkDeleteVisitTypeCategories);
}

